module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEX4TS0cpXKPAAAACklEQVR4nGNiAAAABgADNjd8qAAAAABJRU5ErkJggg=="